import { useEffect } from 'react';

import ScrollSlider from '@com/shared/ocs/scroll-slider';

import DayCard from './DayCard';
import type { BookingDay } from './utils';

type DaysSliderProps = {
  days: BookingDay[];
  selectedDay: BookingDay | null;
  onSelectDay: (day: BookingDay) => void;
};

const DaysSlider = ({ days, selectedDay, onSelectDay }: DaysSliderProps) => {
  useEffect(() => {
    if (!selectedDay) return;

    const dayCardElement = document.getElementById(
      `clinic-day-card-${selectedDay.date}`,
    );
    dayCardElement?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'center',
    });
  }, [selectedDay]);

  if (!days.length) {
    return (
      <div className="py-3 h-36" role="region" aria-label="انتخاب روز">
        <p className="px-4 text-center text-Body/Small text-content-tertiary">
          نوبتی برای نمایش وجود ندارد.
        </p>
      </div>
    );
  }

  return (
    <div
      className="py-3"
      role="region"
      aria-label="انتخاب روز"
      data-testid="healthcare-select-date"
    >
      <ScrollSlider className="gap-x-2 px-4">
        {days.map((day) => (
          <DayCard
            key={day.date}
            id={`clinic-day-card-${day.date}`}
            day={day}
            selected={selectedDay?.date === day.date}
            onSelect={onSelectDay}
          />
        ))}
      </ScrollSlider>
    </div>
  );
};

export default DaysSlider;
